<div class="artifact-container">
    <div class="artifact-display">
        <app-loading-spinner [text]="''" *ngIf="!loaded"></app-loading-spinner>
        <div class="visual-area" *ngIf="loaded">
            <div class="image-container">
                <div *ngIf="artifact.SpeechRecPromptMetadata?.PromptImage; else noImage">
                    <picture>
                        <img src='../assets/pictures/SpeechRecPromptImages/{{ artifact.SpeechRecPromptMetadata.PromptImage }}.png' 
                             style="width:100%" 
                             (error)="$event.target.style.display='none'"
                             (load)="$event.target.style.display='block'">
                        <img src='../assets/pictures/SpeechRecPromptImages/{{ artifact.SpeechRecPromptMetadata.PromptImage }}.svg' 
                             style="width:100%" 
                             (error)="$event.target.style.display='none'"
                             (load)="$event.target.style.display='block'">
                    </picture>
                </div>
                <ng-template #noImage>
                    <div class="no-image-placeholder">No Prompt Image</div>
                </ng-template>
            </div>
        </div>
        <div class="text-area" *ngIf="loaded">
            <div class="artifact-description">
                <h5 style="font-weight: bold; font-size: 1.2vw;">Unit {{ artifact.UnitNumber }} -
                    {{ artifact.ActivityDescription1 }}
                    <span *ngIf="artifact.ActivityDescription1 !== artifact.ActivityDescription2">:
                        {{ artifact.ActivityDescription2 }}</span>
                </h5>
                <h2 class="artifact-date" style="margin-top: 0.5em;">{{ longDateFormat(artifact.DateGenerated) }}</h2>
                <div *ngIf="artifact.SpeechRecPromptMetadata" class="speech-rec-metadata">
                    <div class="status-text" [style.color]="isAnyAttemptCorrect() ? 'green' : 'red'">
                        {{ isAnyAttemptCorrect() ? 'Marked Correct' : 'Marked Incorrect' }}
                    </div>
                    <div class="prompt-text">
                        <strong>Prompt:</strong> {{ artifact.SpeechRecPromptMetadata.PromptText }}
                    </div>
                    <div class="attempts-container" *ngIf="artifact.Data?.Attempts">
                        <div class="attempt-item" *ngFor="let attempt of artifact.Data.Attempts; let i = index">
                            <div class="attempt-header">
                                <span class="attempt-label">Attempt {{i + 1}}</span>
                                <audio controls [src]="getAttemptAudioUrl(attempt)" type="audio/mp3">
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                        </div>
                    </div>
                    <strong>Acceptable Responses:</strong>
                    <div class="acceptable-responses-container" [class.has-overflow]="hasOverflow">
                        <div class="acceptable-responses" #responsesContainer>
                            <div class="response-item">
                                {{ getSortedResponses().join('  |  ') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> 